import React, { useState, useRef } from 'react';
import clsx from 'clsx';
import shallow from 'zustand/shallow';
import i18n from '@pureartisan/simple-i18n';
import { FiInfo } from 'react-icons/fi';
import { Tooltip } from 'reactstrap';
import { toSentenceCase } from './../utils';
import * as Icons from './../../../core/Icons';
import useStore from './../store';

var LayersInput = function LayersInput(props) {
  var _useStore = useStore(function (state) {
    return {
      pointTypes: state.pointTypes,
      interactionsMobile: state.interactionsMobile
    };
  }, shallow),
      pointTypes = _useStore.pointTypes,
      interactionsMobile = _useStore.interactionsMobile; // to manage tooltip state


  var _useState = useState(false),
      tooltipOpen = _useState[0],
      setTooltipOpen = _useState[1];

  var toggle = function toggle() {
    return setTooltipOpen(!tooltipOpen);
  }; // Fetch the icon object from point types.


  var icon = pointTypes.find(function (point) {
    return point.id.indexOf(props.layer.id) > -1;
  });
  var ThisIcon = Icons[props.layer.id] ? Icons[props.layer.id] : Icons['FeaturesIcon'];
  return /*#__PURE__*/React.createElement("div", {
    className: "layer",
    id: "layer-" + props.layer.id
  }, /*#__PURE__*/React.createElement("label", {
    key: "label-" + props.layer.id,
    id: "label-" + props.layer.id
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: props.id,
    name: "scales",
    key: 'layer-input-' + props.layer.id,
    "data-only-one": props.layer.only_one,
    "data-only-one-name": props.layer.only_one_name,
    className: props.isChecked ? 'checked' : '',
    checked: props.isChecked,
    readOnly: true,
    onClick: props.onChange
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('checkmark')
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('icon', "icon-" + icon.id, "color-" + icon.category)
  }, /*#__PURE__*/React.createElement(ThisIcon, null)), /*#__PURE__*/React.createElement("span", null, toSentenceCase(i18n.translate(props.label))), !!props.tooltip && props.tooltip.length > 0 && !interactionsMobile && /*#__PURE__*/React.createElement(FiInfo, {
    className: "icon-info",
    id: 'tip_prompt_' + props.layer.id
  })), !!props.tooltip && props.tooltip.length > 0 && !interactionsMobile && /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    isOpen: tooltipOpen,
    target: 'tip_prompt_' + props.layer.id,
    toggle: toggle,
    autohide: false,
    className: 'tip-prompt-layer',
    dangerouslySetInnerHTML: {
      __html: i18n.translate(props.tooltip)
    }
  }));
};

export default LayersInput;